import { render, staticRenderFns } from "./ButtonView2Component.vue?vue&type=template&id=1b4f817e&scoped=true"
import script from "./ButtonView2Component.vue?vue&type=script&lang=js"
export * from "./ButtonView2Component.vue?vue&type=script&lang=js"
import style0 from "./ButtonView2Component.vue?vue&type=style&index=0&id=1b4f817e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f817e",
  null
  
)

export default component.exports